import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { history } from "../../history";
import styles from "./navbar.module.css";
import { Dropdown,Badge } from "react-bootstrap";
import zh_img from "../../assets/images/languages/zh.png";
import en_img from "../../assets/images/languages/en.png";
import es_img from "../../assets/images/languages/es.png";
import fr_img from "../../assets/images/languages/fr.png";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageIndex: 0, //当前页面
      isOpenMenu: false,
    };
  }

  changeLanguage = (langs) => {
    // 更换语言
    this.props.i18n.changeLanguage(langs);
  };

  componentDidMount() {
    this.initPageIndex();
  }

  initPageIndex = () => {
    const pathname = history.location.pathname;
    switch (pathname) {
      case "/":
        this.setState({ pageIndex: 1 });
        break;
      case "/search":
        this.setState({ pageIndex: 2 });
        break;
      case "/message":
        this.setState({ pageIndex: 3 });
        break;
      case "/userinfo":
        this.setState({ pageIndex: 4 });
        break;
      case "/mall":
        this.setState({ pageIndex: 5 });
        break;
      default:
        this.setState({ pageIndex: 0 });
    }
  };

  //导航选择更改
  handleLinkClick = (pageIndex) => {
    return (e) => {
      if (pageIndex === 1) {
        history.push("/");
      } else if (pageIndex === 2) {
        history.push("/search");
      } else if (pageIndex === 3) {
        history.push("/likes");
      } else if (pageIndex === 4) {
        history.push("/detail");
      }else if (pageIndex === 5) {
        history.push("/mall");
      }
      this.setState({ pageIndex: pageIndex,isOpenMenu:false });
    };
  };

  changeIsOpenMenu = () => {
    const { isOpenMenu } = this.state;

    this.setState({
      isOpenMenu: !isOpenMenu,
    });
  };

  render() {
    const { pageIndex,isOpenMenu } = this.state;
    const { t,i18n,unReadNumber } = this.props;

    const rightNode = () => {
      return (
        <div className={styles.diamond} onClick={this.handleLinkClick(3)}>
            <FontAwesomeIcon
              icon={faBell}
              style={{ color: "#efe701", fontSize: "24px", cursor: "pointer",display:unReadNumber>0?'':'none' }}
            />
            {unReadNumber>0?<Badge bg="danger" pill className={styles.Bellbadge}>{unReadNumber}</Badge>:''}
        </div>
      );
    };

    const languageDiv = () => {
      return (
        <div className={styles.language}>
          <Dropdown>
            <Dropdown.Toggle
              as={"div"}
              className={styles.DropdownTitle}
              style={{ width: "100%" }}
            >
              <div className={styles.language_title}>{t("language_title")}</div>
              <img
                src={i18n.language==='zh'?zh_img:i18n.language==='en'?en_img:i18n.language==='fr'?fr_img:es_img}
                width="30px"
                height="30px"
                style={{ float: "left" }}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu className={styles.LdropMenu} alignRight>
              <Dropdown.Item as={"div"} className={styles.LdropItem}>
                <div
                  className={styles.py1}
                  onClick={() => this.changeLanguage("zh")}
                >
                  <img
                    src={zh_img}
                    width="30px"
                    height="30px"
                    style={{ marginRight: "0.5rem", float: "left" }}
                  />
                  <div className={styles.language_text}>中文</div>
                </div>
              </Dropdown.Item>
              <Dropdown.Item as={"div"} className={styles.LdropItem}>
                <div
                  className={styles.py1}
                  onClick={() => this.changeLanguage("en")}
                >
                  <img
                    src={en_img}
                    width="30px"
                    height="30px"
                    style={{ marginRight: "0.5rem", float: "left" }}
                  />
                  <div className={styles.language_text}>English</div>
                </div>
              </Dropdown.Item>
              <Dropdown.Item as={"div"} className={styles.LdropItem}>
                <div
                  className={styles.py1}
                  onClick={() => this.changeLanguage("es")}
                >
                  <img
                    src={es_img}
                    width="30px"
                    height="30px"
                    style={{ marginRight: "0.5rem", float: "left" }}
                  />
                  <div className={styles.language_text}>Español</div>
                </div>
              </Dropdown.Item>
              <Dropdown.Item as={"div"} className={styles.LdropItem}>
                <div
                  className={styles.py1}
                  onClick={() => this.changeLanguage("fr")}
                >
                  <img
                    src={fr_img}
                    width="30px"
                    height="30px"
                    style={{ marginRight: "0.5rem", float: "left" }}
                  />
                  <div className={styles.language_text}>Français</div>
                </div>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      );
    };

    return (
      <header className={styles.header}>
        <div className={styles.new_container}>
          <div className={styles.wrapper}>
            <div className={styles.header_item_left}>
              <div>
              <a href="/" onClick={this.handleLinkClick(1)}>
                  <span
                    style={{ visibility: "visible" }}
                    className={styles.font_serif}
                  >
                    {t("web_name")}
                  </span>
                </a>
              </div>
            </div>
            <div className={styles.header_item_center}>
            <nav
                  className={
                    isOpenMenu
                      ? `${styles.menu} ${styles.active}`
                      : `${styles.menu}`
                  }
                >
                  <div className={styles.menu_mobile_header}>
                    <div className={styles.menu_mobile_title}>{t("menu_title")}</div>
                    <button
                      type="button"
                      className={styles.menu_mobile_close}
                      onClick={this.changeIsOpenMenu}
                    >
                      x
                    </button>
                  </div>
                  <ul className={styles.menu_section}>
                    <li>
                        <div
                          onClick={this.handleLinkClick(1)}
                          className={pageIndex === 1? `${styles.choose}` : `${styles.nochoose}`}
                          style={{ cursor: 'pointer' }}
                        >
                          {t("menu_discover")}
                        </div>
                    </li>
                   
                    <li>
                        <div
                          onClick={this.handleLinkClick(2)}
                          className={pageIndex === 2? `${styles.choose}` : `${styles.nochoose}`}
                          style={{ cursor: 'pointer' }}
                        >
                          {t("menu_search")}
                        </div>
                    </li>
                    
                    <li>
                        <div
                          onClick={this.handleLinkClick(3)}
                          className={pageIndex === 3? `${styles.choose}` : `${styles.nochoose}`}
                          style={{ cursor: 'pointer' }}
                        >
                          {t("menu_message")}
                          {unReadNumber>0?<Badge bg="danger" pill className={styles.badge}>{unReadNumber}</Badge>:''}
                          
                        </div>
                    </li>

                    <li>
                        <div
                          onClick={this.handleLinkClick(5)}
                          className={pageIndex === 5? `${styles.choose}` : `${styles.nochoose}`}
                          style={{ cursor: 'pointer',color:"#fd1414",fontWeight:'600',fontSize:'20px' }}
                        >
                          MALL
                        </div>
                    </li>

                    <li>
                        <div
                          onClick={this.handleLinkClick(4)}
                          className={pageIndex === 4? `${styles.choose}` : `${styles.nochoose}`}
                          style={{ cursor: 'pointer' }}
                        >
                          {t("menu_account")}
                        </div>
                    </li>
                  </ul>
                </nav>
            </div>
            <div className={styles.header_item_right}>
              <div className={styles.header_item_right_inner}>
                {rightNode()}
                {/* {languageDiv()} */}

                <button
                  type="button"
                  className={styles.menu_mobile_trigger}
                  onClick={this.changeIsOpenMenu}
                ><span style={{ backgroundColor: "#fff" }}></span>
                  <span style={{ backgroundColor: "#fff" }}></span>
                  <span style={{ backgroundColor: "#fff" }}></span>
                  <span style={{ backgroundColor: "#fff" }}></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
export default withTranslation()(connect((state) => ({unReadNumber: state.auth.unReadNumber}), {})(NavBar));
